// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck TODO migrate
import React, { Component } from 'react';
import { type ConnectedProps, connect } from 'react-redux';
import { Navigate } from 'react-router-dom';

import PropTypes from 'prop-types';

import type { RootState } from 'reducers/types';
import { getOrder, getPayment, isLoggedIn } from 'selectors';

const NO_DELAY = 0;

type Props = ConnectedProps<typeof connector>;

class RedirectToTrackingComponent extends Component<Props> {
  static propTypes = {
    delay: PropTypes.number,
    isLoggedIn: PropTypes.bool.isRequired,
    order: PropTypes.object.isRequired,
    payment: PropTypes.object.isRequired,
  };

  static defaultProps = {
    delay: NO_DELAY,
  };

  state = { redirect: false };

  componentDidMount() {
    const { delay } = this.props;
    const timeout = setTimeout(() => this.setState({ redirect: true }), delay);

    this.setState({ timeout });
  }

  componentWillUnmount() {
    const { timeout } = this.state;

    clearTimeout(timeout);
  }

  render() {
    const {
      isLoggedIn,
      order: { id: orderId, token },
      payment: { id: paymentId },
    } = this.props;

    const { redirect } = this.state;

    if (isLoggedIn) {
      return redirect && paymentId && <Navigate to={`/payment/${paymentId}`} />;
    }

    return (
      redirect &&
      orderId && <Navigate to={`/tracking/${orderId}?token=${token}`} />
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  isLoggedIn: isLoggedIn(state),
  order: getOrder(state),
  payment: getPayment(state),
});

const connector = connect(mapStateToProps);
const RedirectToTracking = connector(RedirectToTrackingComponent);

export { RedirectToTracking };
